import {USER_SEGMENT_PARAM} from './constants';

/**
 * Every user segment to send on Constructor browse calls: the segments the
 * CTGY template assigns (`mivaJS.User_Segments`: the category segment plus any
 * `?us=` values in the page URL), plus any `?us=` values in the page URL for
 * pages the template doesn't cover. De-duplicated, in that order.
 *
 * @returns {string[]}
 */
export const userSegments = () => {
	const templateSegments = window.mivaJS?.User_Segments ?? [];
	const urlSegments = new URLSearchParams(window.location.search).getAll(USER_SEGMENT_PARAM);
	const segments = [
		...templateSegments,
		...urlSegments
	]
		.map(segment => segment.trim())
		.filter(Boolean);

	return [...new Set(segments)];
};
